import { supabaseConfig } from "./supabaseConfig";

export function validSupabaseConfig(config) {
  try {
    const url = new URL(config.url);
    return url.protocol === "https:" && !url.username && !url.password &&
      typeof config.publishableKey === "string" && config.publishableKey.startsWith("sb_publishable_");
  } catch { return false; }
}

export const accountsConfigured = validSupabaseConfig(supabaseConfig);
let clientPromise;

// One app-level client; do not create a separate session manager per page.
export async function getSupabaseClient() {
  if (!accountsConfigured) return null;
  if (!clientPromise) {
    clientPromise = import("@supabase/supabase-js").then(({ createClient }) =>
      createClient(supabaseConfig.url, supabaseConfig.publishableKey, {
        auth: { flowType: "pkce", persistSession: true, autoRefreshToken: true,
          detectSessionInUrl: ["/account/callback", "/account/reset-password"].includes(window.location.pathname) },
      })
    ).catch(error => { clientPromise = null; throw error; });
  }
  return clientPromise;
}
